(function() {
  'use strict';

  function hideEmptyParagraphs() {
    document.querySelectorAll('article p').forEach(function(p) {
      // Hide paragraphs that have no child elements AND only whitespace/nbsp content
      if (p.children.length === 0 && p.textContent.replace(/[\s\u00A0]/g, '') === '') {
        p.style.display = 'none';
      }
    });
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideEmptyParagraphs);
  } else {
    hideEmptyParagraphs();
  }
})();

// Preserve scroll position when modals open (quick view, etc.)
// When 'modal-open' is added to <html>, overflow:hidden resets scrollY to 0.
// Fix: track scroll continuously so we have the value before the reset occurs,
// then lock body with position:fixed at that offset and restore on close.
(function() {
  'use strict';

  var savedScrollY = 0;
  var isLocked = false;

  // Track scroll position at all times — window.scrollY is already 0 by the
  // time the MutationObserver fires after overflow:hidden has been applied.
  window.addEventListener('scroll', function() {
    if (!isLocked) {
      savedScrollY = window.scrollY || window.pageYOffset;
    }
  }, { passive: true });

  function lockScroll() {
    if (isLocked) return;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + savedScrollY + 'px';
    document.body.style.width = '100%';
    document.body.style.overflowY = 'scroll';
    isLocked = true;
  }

  function unlockScroll() {
    if (!isLocked) return;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflowY = '';
    window.scrollTo(0, savedScrollY);
    isLocked = false;
  }

  var observer = new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].attributeName === 'class') {
        if (document.documentElement.classList.contains('modal-open')) {
          lockScroll();
        } else {
          unlockScroll();
        }
        break;
      }
    }
  });

  document.addEventListener('DOMContentLoaded', function() {
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  });
})();

// Search results height calculation for mobile
(function() {
  'use strict';

  function updateSearchResultsHeight() {
    var searchEl = document.querySelector('predictive-search.is-active');
    if (!searchEl) return;

    var resultsEl = searchEl.querySelector('.search__results');
    var inputWrap = searchEl.querySelector('.search__input-wrap');
    if (!resultsEl || !inputWrap) return;

    // Get the bottom position of the input wrapper
    var inputRect = inputWrap.getBoundingClientRect();
    var inputBottom = inputRect.bottom;

    // Calculate available height: viewport height minus input bottom position minus small buffer
    var availableHeight = window.innerHeight - inputBottom - 10;

    resultsEl.style.setProperty('--search-results-height', availableHeight + 'px');
  }

  // Hide/show wishlist float when search opens/closes
  function toggleWishlistFloat(hide) {
    var wishlistFloat = document.querySelector('.xb-wishlist__float-style-1');
    if (wishlistFloat) {
      wishlistFloat.style.display = hide ? 'none' : '';
    }
  }

  // Listen for search open event
  document.addEventListener('predictive-search:open', function() {
    // Small delay to ensure DOM is updated
    setTimeout(updateSearchResultsHeight, 50);
    toggleWishlistFloat(true);
  });

  // Listen for search close event
  document.addEventListener('predictive-search:close', function() {
    toggleWishlistFloat(false);
  });

  document.addEventListener('predictive-search:close-all', function() {
    toggleWishlistFloat(false);
  });

  // Also update on resize
  window.addEventListener('resize', function() {
    if (document.querySelector('predictive-search.is-active')) {
      updateSearchResultsHeight();
    }
  });
})();

// Quick View: fix double-click issue on mobile/small screens
// The theme preloads modal content on mouseover/touchstart (async fetch),
// but on mobile the click fires before the fetch completes, so nothing happens.
// This intercepts the click and loads + opens the modal if it's not ready yet.
(function() {
  'use strict';

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.quick-product__btn');
    if (!btn) return;

    var gridProduct = btn.closest('.grid-product');
    if (!gridProduct) return;

    var handle = gridProduct.dataset.productHandle;
    var productId = gridProduct.dataset.productId;
    if (!handle || !productId) return;

    var holder = document.getElementById('QuickShopHolder-' + handle);
    // If modal content is already loaded, let the existing Modals click handler work
    if (holder && holder.children.length > 0) return;

    // Modal not loaded yet - stop the click and load it ourselves
    e.preventDefault();
    e.stopImmediatePropagation();

    if (typeof theme === 'undefined' || typeof theme.preloadProductModal !== 'function') return;

    var url = theme.routes.home + '/products/' + handle + '?view=modal';
    url = url.replace('//', '/');

    fetch(url)
      .then(function(r) { return r.text(); })
      .then(function(text) {
        var html = document.createElement('div');
        html.innerHTML = text;
        var div = html.querySelector('.product-section[data-product-handle="' + handle + '"]');

        if (!holder || !div) return;

        holder.innerHTML = '';
        holder.append(div);

        var modalId = 'QuickShopModal-' + productId;
        var name = 'quick-modal-' + productId;
        var modal = new theme.Modals(modalId, name);

        console.log('[LR click] about to call theme.sections.register for holder:', holder.id, 'patched:', !!theme.sections.register.__lrPatched);
        theme.sections.register('product', theme.Product, holder);
        theme.collapsibles.init();
        theme.videoModal();

        // Auto-open the modal
        modal.open();
      });
  }, true); // Use capture phase to fire before the Modals click handler
})();

// Wrap theme.sections.register to init Make-filter for quick shop modals
// openModalProduct injects blocks ASYNC after sections.register fires, so we use
// a MutationObserver on [data-blocks-holder] to wait for the injection to complete.
document.addEventListener('DOMContentLoaded', function() {
  console.log('[LR wrapper] DOMContentLoaded - theme:', !!window.theme, 'theme.sections:', !!(window.theme && theme.sections), '__lrMakeFilter:', !!window.__lrMakeFilter);
  if (!window.theme || !theme.sections || typeof theme.sections.register !== 'function') {
    console.warn('[LR wrapper] Cannot patch - theme.sections.register not available');
    return;
  }
  if (theme.sections.register.__lrPatched) {
    console.log('[LR wrapper] Already patched');
    return;
  }

  var _orig = theme.sections.register.bind(theme.sections);

  theme.sections.register = function(type, constructor, scope) {
    console.log('[LR wrapper] theme.sections.register called - type:', type, 'scope.id:', scope && scope.id);
    var isModalHolder = type === 'product' && scope && scope.id &&
                        scope.id.indexOf('QuickShopHolder-') === 0;

    var result = _orig(type, constructor, scope);

    if (isModalHolder && window.__lrMakeFilter) {
      console.log('[LR wrapper] QuickShopHolder detected - watching for blocks injection');
      var blocksHolder = scope.querySelector('[data-blocks-holder]');
      if (!blocksHolder) {
        // No lazy-load placeholder — blocks are already inline, init immediately
        console.log('[LR wrapper] No blocks-holder, init immediately');
        window.__lrMakeFilter.buildForContainer(scope);
        window.__lrMakeFilter.initForModal(scope);
      } else if (blocksHolder.classList.contains('product-form-holder--loaded') ||
                 (blocksHolder.children.length > 0 && !blocksHolder.querySelector('.placeholder-content'))) {
        // Already loaded
        console.log('[LR wrapper] blocks-holder already loaded, init now');
        window.__lrMakeFilter.buildForContainer(scope);
        window.__lrMakeFilter.initForModal(scope);
      } else {
        // Wait for openModalProduct to inject blocks
        console.log('[LR wrapper] blocks-holder empty, attaching MutationObserver');
        var obs = new MutationObserver(function(_mutations, observer) {
          var loaded = blocksHolder.classList.contains('product-form-holder--loaded') ||
                       (blocksHolder.children.length > 0 && !blocksHolder.querySelector('.placeholder-content'));
          if (loaded) {
            observer.disconnect();
            console.log('[LR wrapper] blocks injected, calling buildForContainer + initForModal');
            window.__lrMakeFilter.buildForContainer(scope);
            window.__lrMakeFilter.initForModal(scope);
          }
        });
        obs.observe(blocksHolder, { childList: true, attributes: true, attributeFilter: ['class'] });
      }
    }

    return result;
  };
  theme.sections.register.__lrPatched = true;
  console.log('[LR wrapper] theme.sections.register patched successfully');
});

// Close nav drawer when search icon inside it is clicked
document.addEventListener('DOMContentLoaded', function() {
  var searchBtn = document.querySelector('#NavDrawer .drawer-icon--search');
  if (!searchBtn) return;
  searchBtn.addEventListener('click', function() {
    if (theme && theme.NavDrawer) theme.NavDrawer.close();
  });
});

// Mobile drill-down navigation
(function() {
  'use strict';

  function initMobileNav() {
    var track = document.getElementById('MobNavTrack');
    var l2View = document.getElementById('MobNavL2');
    var l3View = document.getElementById('MobNavL3');
    var backBtn = document.querySelector('#NavDrawer .mobile-nav__back');
    var titleEl = document.querySelector('#NavDrawer .mobile-nav__title');
    var subheader = document.querySelector('#NavDrawer .drawer__fixed-header');

    if (!track || !l2View || !l3View || !backBtn || !titleEl) return;

    var levelHistory = [];

    function slideTo(level) {
      var offset = (level - 1) * -100;
      track.style.transform = 'translateX(' + offset + '%)';

      document.getElementById('MobNavL1').removeAttribute('aria-hidden');
      l2View.setAttribute('aria-hidden', 'true');
      l3View.setAttribute('aria-hidden', 'true');

      if (level === 2) {
        l2View.removeAttribute('aria-hidden');
      } else if (level === 3) {
        l2View.removeAttribute('aria-hidden');
        l3View.removeAttribute('aria-hidden');
      }

      if (level === 1) {
        backBtn.hidden = true;
        titleEl.textContent = '';
        if (subheader) subheader.hidden = true;
      } else {
        backBtn.hidden = false;
        if (subheader) subheader.hidden = false;
      }
    }

    function populateView(viewEl, dataId) {
      var source = document.getElementById(dataId);
      if (!source) return null;
      var list = viewEl.querySelector('.mobile-nav__view-list');
      list.innerHTML = source.innerHTML;
      viewEl.scrollTop = 0;
      return source;
    }

    function resetNav() {
      levelHistory = [];
      var l2List = l2View.querySelector('.mobile-nav__view-list');
      var l3List = l3View.querySelector('.mobile-nav__view-list');
      if (l2List) l2List.innerHTML = '';
      if (l3List) l3List.innerHTML = '';
      slideTo(1);
    }

    // L1 → L2
    document.getElementById('MobNavL1').addEventListener('click', function(e) {
      var btn = e.target.closest('[data-l2-id]');
      if (!btn) return;
      var source = populateView(l2View, btn.dataset.l2Id);
      if (!source) return;
      levelHistory.push({ level: 1, title: '' });
      titleEl.textContent = btn.dataset.title || '';
      slideTo(2);
    });

    // L2 → L3 (delegated — l2View content is dynamically populated)
    l2View.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-l3-id]');
      if (!btn) return;
      var source = populateView(l3View, btn.dataset.l3Id);
      if (!source) return;
      levelHistory.push({ level: 2, title: titleEl.textContent });
      titleEl.textContent = btn.dataset.title || '';
      slideTo(3);
    });

    // Back
    backBtn.addEventListener('click', function() {
      var prev = levelHistory.pop();
      if (!prev) { slideTo(1); return; }
      titleEl.textContent = prev.title;
      slideTo(prev.level);
    });

    // Reset when NavDrawer opens so it always starts at L1
    // Theme fires a custom event or uses the Drawers class — intercept the hamburger click
    document.querySelectorAll('.js-drawer-open-nav').forEach(function(btn) {
      btn.addEventListener('click', function() {
        // Small delay lets the drawer open animation start first
        setTimeout(resetNav, 50);
      });
    });

    // Also reset on ESC
    document.addEventListener('keyup', function(e) {
      if (e.key === 'Escape') resetNav();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileNav);
  } else {
    initMobileNav();
  }
})();

// Megamenu level 3 flyout
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.megamenu__col-title').forEach(function(colTitle) {
    var wrapper = colTitle.closest('.megamenu__wrapper');
    if (!wrapper) return;
    var panel = wrapper.querySelector('.megamenu__sublevel-panel');
    if (!panel) return;

    colTitle.addEventListener('mouseenter', function() {
      var source = this.querySelector('.megamenu__sublevel');
      if (source) {
        panel.innerHTML = source.innerHTML;
        wrapper.classList.add('megamenu--has-sublevel');
      } else {
        wrapper.classList.remove('megamenu--has-sublevel');
        panel.innerHTML = '';
      }
    });
  });

  document.querySelectorAll('.megamenu__wrapper').forEach(function(wrapper) {
    wrapper.addEventListener('mouseleave', function() {
      this.classList.remove('megamenu--has-sublevel');
      var panel = this.querySelector('.megamenu__sublevel-panel');
      if (panel) panel.innerHTML = '';
    });
  });
});

// Mobile currency: navigate to Shopify market URL /{lang}-{country}/path
document.addEventListener('click', function(e) {
  var link = e.target.closest('[data-mobile-currency]');
  if (!link) return;
  e.preventDefault();

  var CURRENCY_TO_COUNTRY = {
    USD: 'us', EUR: 'eu', GBP: 'gb', AUD: 'au', CAD: 'ca', CHF: 'ch'
  };

  var currency = link.getAttribute('data-mobile-currency');
  var country = CURRENCY_TO_COUNTRY[currency];
  if (!country) return;

  var path = window.location.pathname;
  var match = path.match(/^\/([a-z]{2})(?:-[a-z]{2})?(\/.*)?$/i);
  var lang = match ? match[1].toLowerCase() : null;
  var rest = (match && match[2]) ? match[2] : '';

  var newPath;
  if (!lang && country === 'us') {
    newPath = rest || '/';
  } else if (!lang) {
    newPath = '/en-' + country + rest;
  } else if (lang === 'en' && country === 'us') {
    newPath = rest || '/';
  } else {
    newPath = '/' + lang + '-' + country + rest;
  }

  window.location.href = newPath;
});

// Product image hover zoom + magnifier icon
// Desktop: hover zooms 2x following cursor; magnifier icon click opens PhotoSwipe fullscreen
// Mobile:  tap image toggles zoom; tap magnifier icon opens PhotoSwipe fullscreen
(function() {
  'use strict';

  var ZOOM_SCALE = 2;
  var MOBILE_BREAKPOINT = 590;

  function resetZoom(zoomEl, imageMain) {
    zoomEl.style.transition = '';
    zoomEl.style.transform = '';
    zoomEl.style.transformOrigin = '';
    imageMain.classList.remove('is-zoomed');
  }

  function resetAllZoom() {
    document.querySelectorAll('.product-image-main').forEach(function(imageMain) {
      var zoomEl = imageMain.querySelector('.image-wrap image-element');
      if (zoomEl) resetZoom(zoomEl, imageMain);
    });
  }

  // CAPTURE PHASE: reset zoom before PhotoSwipe's bubble-phase handler calls
  // getBoundingClientRect() on the image. A scaled element returns wrong bounds
  // which breaks the open animation (especially on mobile).
  document.addEventListener('click', function(e) {
    var btn = e.target && typeof e.target.closest === 'function'
      ? e.target.closest('.js-photoswipe__zoom')
      : null;
    if (!btn) return;
    var imageMain = btn.closest('.product-image-main');
    if (!imageMain) return;
    var zoomEl = imageMain.querySelector('.image-wrap image-element');
    if (!zoomEl) return;
    zoomEl.style.transition = 'none'; // instant reset, no visual snap
    zoomEl.style.transform = '';
    zoomEl.style.transformOrigin = '';
    imageMain.classList.remove('is-zoomed');
    setTimeout(function() { if (zoomEl) zoomEl.style.transition = ''; }, 100);
  }, true); // capture phase fires before PhotoSwipe's bubble listener

  function initProductImageZoom() {
    document.querySelectorAll('.product-image-main').forEach(function(imageMain) {
      if (imageMain.__lrZoomBound) return; // idempotent — safe to re-init after slider rebuild
      imageMain.__lrZoomBound = true;
      var imageWrap = imageMain.querySelector('.image-wrap');
      // Zoom target: <image-element> custom tag (position:absolute, fills .image-wrap).
      // Scaling it is clipped by .image-wrap { overflow:hidden } for a clean zoom.
      var zoomEl = imageMain.querySelector('.image-wrap image-element');
      if (!zoomEl || !imageWrap) return;

      function applyZoom(e) {
        var rect = imageWrap.getBoundingClientRect();
        var x = Math.max(0, Math.min(100, ((e.clientX - rect.left) / rect.width) * 100));
        var y = Math.max(0, Math.min(100, ((e.clientY - rect.top) / rect.height) * 100));
        zoomEl.style.transformOrigin = x + '% ' + y + '%';
        zoomEl.style.transform = 'scale(' + ZOOM_SCALE + ')';
      }

      // Desktop: zoom on hover, pan with cursor
      imageMain.addEventListener('mouseenter', function(e) {
        if (window.innerWidth < MOBILE_BREAKPOINT) return;
        applyZoom(e);
      });

      imageMain.addEventListener('mousemove', function(e) {
        if (window.innerWidth < MOBILE_BREAKPOINT) return;
        applyZoom(e);
      });

      imageMain.addEventListener('mouseleave', function() {
        if (window.innerWidth < MOBILE_BREAKPOINT) return;
        resetZoom(zoomEl, imageMain);
      });

      // Mobile: tap anywhere on image → open PhotoSwipe fullscreen
      imageMain.addEventListener('click', function(e) {
        if (window.innerWidth >= MOBILE_BREAKPOINT) return;
        var isZoomBtn = e.target && typeof e.target.closest === 'function'
          ? e.target.closest('.js-photoswipe__zoom')
          : null;
        if (isZoomBtn) return; // already handled by PhotoSwipe directly
        var zoomBtn = imageMain.querySelector('.js-photoswipe__zoom');
        if (zoomBtn) zoomBtn.click();
      });
    });

    // Reset zoom when user starts a swipe gesture
    var productPhotos = document.querySelector('[data-product-photos]');
    if (productPhotos) {
      productPhotos.addEventListener('touchstart', resetAllZoom, { passive: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductImageZoom);
  } else {
    initProductImageZoom();
  }

  // Expose so slider rebuild code (theme.js, lr-make-filter.js) can re-bind zoom on new slides
  window.__lrInitProductImageZoom = initProductImageZoom;
})();

// Lazy video loading for review carousel Swiper
// Hero slider handles its own lazy loading inline in its section script.
(function() {
  'use strict';

  function loadSlideVideos(slide) {
    if (!slide) return;
    // Single source: data-lazy-src + data-lazy-type on <video>
    slide.querySelectorAll('video[data-lazy-src]').forEach(function(video) {
      var src  = video.dataset.lazySrc;
      var type = video.dataset.lazyType || 'video/mp4';
      video.removeAttribute('data-lazy-src');
      video.removeAttribute('data-lazy-type');
      var source = document.createElement('source');
      source.src  = src;
      source.type = type;
      video.appendChild(source);
      video.load();
      if (video.hasAttribute('autoplay')) video.play().catch(function() {});
    });
    // Multiple sources: encoded as "url|type;url|type" in data-lazy-sources on <video>
    slide.querySelectorAll('video[data-lazy-sources]').forEach(function(video) {
      var encoded = video.dataset.lazySources;
      video.removeAttribute('data-lazy-sources');
      encoded.split(';').forEach(function(pair) {
        var parts  = pair.split('|');
        var source = document.createElement('source');
        source.src  = parts[0];
        source.type = parts[1] || '';
        video.appendChild(source);
      });
      video.load();
      if (video.hasAttribute('autoplay')) video.play().catch(function() {});
    });
  }

  function initCarouselLazyLoad(swiper) {
    var LOAD_AHEAD = 3; // covers 2.2-per-view desktop + 1 ahead

    function loadRange(from) {
      var end = Math.min(from + LOAD_AHEAD, swiper.slides.length);
      for (var i = from; i < end; i++) {
        loadSlideVideos(swiper.slides[i]);
      }
    }

    loadRange(swiper.activeIndex);

    swiper.on('slideChangeTransitionStart', function() {
      loadRange(this.activeIndex);
    });
  }

  function tryInit() {
    var reviewEl = document.querySelector('[class*="lr-swiper-"]');
    if (!reviewEl) { clearInterval(poll); return; }
    if (!reviewEl.swiper) return;

    clearInterval(poll);
    initCarouselLazyLoad(reviewEl.swiper);
  }

  var poll = setInterval(tryInit, 100);
  setTimeout(function() { clearInterval(poll); }, 5000);
})();

// Version B: show #chat-button only after scrolling past the fold
(function() {
  'use strict';

  if (!document.querySelector('.version-b')) return;

  var chatBtn = document.getElementById('chat-button');
  if (!chatBtn) {
    // Chat button may load after page — wait for it
    var observer = new MutationObserver(function() {
      chatBtn = document.getElementById('chat-button');
      if (chatBtn) { observer.disconnect(); attachScroll(); }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    attachScroll();
  }

  function attachScroll() {
    function onScroll() {
      if (window.scrollY >= window.innerHeight) {
        chatBtn.classList.add('lr-chat-visible');
        window.removeEventListener('scroll', onScroll);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    // Check immediately in case page is already scrolled
    onScroll();
  }
})();
